import {MessageCodes} from "../MessageCodes";
import ResultHeader from "../../Table/ResultHeader";
import ResultRow from "../../Table/ResultRow";
import ResultBody from "../../Table/ResultBody";
import ResultBodyCell from "../../Table/ResultBodyCell";
import ResultHeaderCell from "../../Table/ResultHeaderCell";
import ResultTable from "../../Table/ResultTable";
import EmptyLine from "../../EmptyLine";
import ResultText from "../ResultText";
import CheckCSName from "../../CheckCSName";
import NO_OUT_Component from "../NO_OUT_Component";
import {useUser} from "../../../Context/UserContext";
import HecRasHelper from "../../../Helpers/HecRasHelper";
import ResultView from "../../V2/ResultView";

export function B1({data, message_key}) {
    const {settings} = useUser()

    return (
        <>
            {
                data?.result?.map(row => (
                    <ResultView error_id={row?.error_id} message_key={message_key}>
                        <Description row={row} settings={settings} globalVariables={data?.global_variables} />
                    </ResultView>
                ))
            }
        </>
    )
}

const Description = ({row, settings, globalVariables}) => {
    if(row.error_id === MessageCodes.Internal.SRC00.error_id) {
        return  (
            <ResultText>
                {row.error_message}
            </ResultText>
        )
    }
    else if(row.error_id === MessageCodes.Internal.TSRC001.error_id) {
        return (
            <>
                <ResultText>
                    {/*There are encroachment surcharges either greater than {settings.thresholds.delta_ws_gt} ft or lower than {settings.thresholds.delta_ws_lt} at the following {row?.data?.length} cross sections.*/}
                    There are encroachment surcharges either greater than {settings.thresholds.delta_ws_gt} ft or negative at the following {row?.data?.length} cross sections.
                    <EmptyLine />
                </ResultText>
                <ResultTable data={row}>
                    <ResultHeader>
                        <ResultRow>
                            <ResultHeaderCell style={{textAlign: 'left', width: HecRasHelper.getWidth(15)}}>River Station</ResultHeaderCell>
                            <ResultHeaderCell style={{textAlign: 'right', width: HecRasHelper.getWidth(15)}}>Surcharge (ft)</ResultHeaderCell>
                        </ResultRow>
                    </ResultHeader>
                    <ResultBody>
                        {
                            (row.data || [{}]).map(r => {
                                return (
                                    <ResultRow>
                                        <ResultBodyCell style={{textAlign: 'left'}}><CheckCSName csName={r.cross_section || '{cross_section}'} /></ResultBodyCell>
                                        <ResultBodyCell style={{textAlign: 'right'}}>{r.femafw_prof_delta_ws || '{femafw_prof_delta_ws}'}</ResultBodyCell>
                                    </ResultRow>
                                )
                            })
                        }
                    </ResultBody>
                </ResultTable>
            </>
        )
    }
    else if(row.error_id === MessageCodes.Internal.TSRCICS001.error_id) {
        return (
            <>
                <ResultText>
                    {/*There are encroachment surcharges either greater than {settings.thresholds.delta_ws_gt} ft or lower than {settings.thresholds.delta_ws_lt} at the following {row?.data?.length} internal cross sections.*/}
                    There are encroachment surcharges either greater than {settings.thresholds.delta_ws_gt} ft or negative at the following {row?.data?.length} internal bridge cross sections.
                    <EmptyLine />
                </ResultText>
                <ResultTable data={row}>
                    <ResultHeader>
                        <ResultRow>
                            <ResultHeaderCell style={{textAlign: 'left', width: HecRasHelper.getWidth(15)}}>River Station</ResultHeaderCell>
                            <ResultHeaderCell style={{textAlign: 'right', width: HecRasHelper.getWidth(15)}}>Surcharge (ft)</ResultHeaderCell>
                        </ResultRow>
                    </ResultHeader>
                    <ResultBody>
                        {
                            (row.data || [{}]).map(r => {
                                return (
                                    <ResultRow>
                                        <ResultBodyCell style={{textAlign: 'left'}}><CheckCSName csName={r.cross_section || '{cross_section}'} /></ResultBodyCell>
                                        <ResultBodyCell style={{textAlign: 'right'}}>{r.femafw_prof_delta_ws || '{femafw_prof_delta_ws}'}</ResultBodyCell>
                                    </ResultRow>
                                )
                            })
                        }
                    </ResultBody>
                </ResultTable>
            </>
        )
    }
    else if(row.error_id === MessageCodes.Internal.FW02.error_id) {
        return (
            <>
                <ResultText>
                    Flow changes with more than {settings?.thresholds?.flow_change_rate} % are highlighted in the flow table.
                    <EmptyLine />
                </ResultText>
                <ResultTable data={row}>
                    <ResultHeader>
                        <ResultRow>
                            <ResultHeaderCell style={{textAlign: 'left', width: HecRasHelper.getWidth(15)}}>River Station</ResultHeaderCell>
                            <ResultHeaderCell colSpan={4} style={{textAlign: 'right', width: HecRasHelper.getWidth(15)}}>Surcharge (ft)</ResultHeaderCell>
                        </ResultRow>
                    </ResultHeader>
                    <ResultBody>

                    </ResultBody>
                </ResultTable>
            </>
        )
    }
    else if(row.error_id === MessageCodes.Internal.B1_NOOUT01.error_id) {
        return (
            <>
                <NO_OUT_Component error={row}/>
            </>
        )
    }
    else if(row.error_id === MessageCodes.Internal.B1_NOOUT02.error_id) {
        return (
            <>
                <NO_OUT_Component error={row}/>
            </>
        )
    }
}